export default __webpack_public_path__ + "static/media/Y2.de66b2b5.jpg";